// extracted by mini-css-extract-plugin
module.exports = {"box":"SmallLogo_box__2wHg1","top":"SmallLogo_top__3Y2tU","bottom":"SmallLogo_bottom__2bKH_","logo":"SmallLogo_logo__10MX2","charity":"SmallLogo_charity__1m0ut"};